module.exports = __webpack_public_path__ + "static/media/italic_w.1fa7b5d4.svg";